module.exports = __webpack_public_path__ + "img/Logo-15.a3171693.svg";